<template>
  <v-row align="center" justify="center" no-gutters>
    <v-col cols="12" justify="center" align="center">
      <v-img
        class="bg"
        :src="require('@/assets/imgs/' + imgNmae)"
        max-height="470"
        gradient="to left,  rgba(0, 0, 0, 0.5) ,rgba(0, 0, 0, .5)"
      >
        <v-row justify="center" align="center" style="height: 100%"> 
          <v-col cols="12" justify="center" align="center">
            <div class="header">
              <span>Trusted Leaders in Technology Solutions</span>
            </div>
            <v-btn
              width="240px"
              rounded
              outlined
              class="ml-2 black--text contact-us-btn mt-12"
              style="border-color: rgba(0, 0, 0, 0.5)"
              >Contact us today</v-btn
            >
          </v-col>
        </v-row>
      </v-img>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      imgNmae: "gettyimages.jpg",
    };
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 992px) {
  .header span {
    font-size: 20px !important;
  }
  .contact-us-btn {
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 600px) {
  .header span {
    font-size: 16px !important;
  }
  .contact-us-btn {
    font-size: 10px !important;
    width: 140px !important;
  }
}
.contact-us-btn {
 
  background-color: #f9f9f9;
  color: black;
  font-size: 16px;
  font-family: Raleway;
}
.header {
 
  span {
    letter-spacing: 2px;
    font-size: 36px;
    font-weight: 700;
    font-family: Raleway;
    color: white;
  }
}
</style>